import { Fragment } from "react";
import { Button, Modal, ModalProps, Spin } from "@arco-design/web-react";
import useRequest from "@/requestHooks/mixCutDetail/useRequest";
import { getUpdateTime } from "@/services/createSpace/graphQ/getSimpleMedia";
import "./LinkProjectModal.less";
import { SourceType } from "@/services/createSpace/material";
import { getMaterailLinkEngineerList } from "@/services/createSpace/graphQ/getMaterialLinkEngineer";
import EngineerCard from "@/pages/CreationSpace/components/EngineerCard/EngineerCard";
import useNavigateTo from "@/utils/useNavigateTo";

interface ILinkProjectModal extends ModalProps {
  id: number;
  projectId: number;
  type: SourceType;
}

const LinkProjectModal: React.FC<ILinkProjectModal> = (props) => {
  const { id, onCancel, projectId, visible, type, ...rest } = props;
  const { navigateTo } = useNavigateTo();
  const { data, loading } = useRequest({
    request: getMaterailLinkEngineerList,
    initSearchData: {
      id,
    },
    page: {
      page: 1,
      page_size: 10000,
    },
  });

  return (
    <>
      <Modal
        {...rest}
        onCancel={() => {
          onCancel();
        }}
        visible={visible}
        style={{ width: 625 }}
        title={"关联工程"}
        footer={
          <>
            <Button
              onClick={() => {
                onCancel();
              }}
            >
              取消
            </Button>
          </>
        }
      >
        <div className="link-project-container-wrapper">
          <Spin
            loading={loading === "loading"}
            style={{
              width: "100%",
              height: "100%",
              padding: "20px",
              boxSizing: "border-box",
              overflowY: "auto",
              paddingTop: 20,
            }}
          >
            <div className="link-project-container">
              {(data || []).map((item) => {
                return (
                  <Fragment key={item.id}>
                    <EngineerCard
                      title={item.title}
                      updateTime={getUpdateTime(item.updated_at)}
                      isOperate={false}
                      checkBoxState={false}
                      type={item.type}
                      handleCheckboxChange={(e) => {
                        console.log(e);
                      }}
                      avatorList={[
                        {
                          avator: item?.owner?.avatar_color,
                          name: item?.owner?.nickname,
                        },
                      ]}
                      onClick={() => {
                        // window.open(`/mix-detail/${item.id}`, "_blank");
                        if (item.type === 5) {
                          navigateTo(`/cloud-clip?id=${item.id}`);
                        } else if (item.type === 1) {
                          navigateTo(`/mix-detail/${item.id}`);
                        } else if (item.type === 3) {
                          navigateTo(`/image-text?id=${item.id}`);
                        } else if (item.type === 6) {
                          navigateTo(`/quick-cut/${item.id}`);
                        }
                      }}
                    />
                  </Fragment>
                );
              })}
            </div>
          </Spin>
        </div>
      </Modal>
    </>
  );
};

export default LinkProjectModal;
